import React from 'react';
import Select from 'react-select';
import { defaultStyle } from '../Select/SelectConfig';
import { DropdownIndicatorProps, components } from 'react-select';
import styles from './Dropdown.module.scss';

function DropdownIndicator(props: DropdownIndicatorProps) {
  return (
    <components.DropdownIndicator
      {...props}
      className={styles['dropdown-container']}
    >
      <i className={`fa-solid fa-angle-down ${styles['icon']}`}></i>
    </components.DropdownIndicator>
  );
}

export default function Dropdown({
  options,
  id,
  placeholder = 'Select',
  selectedOption,
  onOptionChange,
  disabled,
  onFocus,
  onBlur,
  style,
  isClearable,
}: any) {
  return (
    <div>
      <div className="item-text-right ">
        <Select
          options={options}
          isDisabled={disabled}
          styles={style ? style : defaultStyle}
          onChange={(e) => onOptionChange(e)}
          placeholder={placeholder}
          isSearchable={false}
          value={selectedOption}
          onFocus={onFocus}
          onBlur={onBlur}
          isClearable={!disabled && isClearable}
          id={id}
          menuShouldScrollIntoView={false}
          components={{ DropdownIndicator, IndicatorSeparator: null }}
        ></Select>
      </div>
    </div>
  );
}
